import { AlertTriangle } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative bg-[#000000] py-12 border-t border-[#CFAE58]/20">
      <div className="container mx-auto px-4">
        {/* Disclaimer */}
        <div className="max-w-5xl mx-auto mb-8">
          <div className="bg-gradient-to-r from-red-900/20 to-transparent border border-red-500/30 rounded-2xl p-6">
            <div className="flex items-start gap-4">
              <AlertTriangle className="w-8 h-8 text-red-400 flex-shrink-0 mt-1" />
              <div>
                <h3 className="text-red-400 text-xl mb-2">⚠️ تنويه مهم</h3>
                <p className="text-gray-300 leading-relaxed">
                  التداول في الأسواق المالية يحتوي على مخاطر وقد يؤدي إلى خسارة رأس المال.
                  النتائج السابقة لا تضمن النتائج المستقبلية. يجب عليك فهم المخاطر المرتبطة بالتداول
                  قبل البدء في أي نشاط استثماري.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Elev8 Club Branding */}
        <div className="text-center mb-6">
          <div className="inline-block">
            <h3 className="text-3xl text-[#CFAE58] mb-2">Elev8 Club</h3>
            <div className="h-1 bg-gradient-to-r from-transparent via-[#CFAE58] to-transparent"></div>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center text-gray-400">
          <p>© 2025 Elev8 Club – جميع الحقوق محفوظة.</p>
        </div>

        {/* Decorative Elements */}
        <div className="absolute bottom-0 left-0 w-32 h-32 bg-[#CFAE58] rounded-full blur-[100px] opacity-10"></div>
        <div className="absolute bottom-0 right-0 w-32 h-32 bg-[#0A1E3F] rounded-full blur-[100px] opacity-10"></div>
      </div>
    </footer>
  );
}
